class LanguageSwitcher {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-language="scope"]',
			select: '[data-language="select"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('change', this.config.select, this.changeLanguage.bind(this))
	}

	changeLanguage(event) {
		let $select = $(event.currentTarget);
		window.location.href = $select.val();
	}
}

export default new LanguageSwitcher;